import { getRules } from '@/components/prod/center/components/TBInfoForm/utils/rules'
import Input from '../components/Input/index'
import Editor from '../components/Input/Editor'
import InputNumber from '../components/Input/InputNumber'
import InputTime from '../components/Input/InputTime'
import Select from '../components/Select/index'
import Step1Select from '../components/Select/Step1Select'
import Complex from '../components/Complex/index'
import Images from '../components/Complex/Images'
import PostageSelects from '../components/Complex/PostageSelects'
import Specifications from '../components/MultiComplex/Specifications'
import AuctionVideos from '../components/MultiComplex/AuctionVideos.vue'
import MultiComplex from '../components/MultiComplex/index'
import SizeModelTry from '../components/MultiComplex/SizeModelTry.vue'
import ShoppingTitle from '../components/Complex/ShoppingTitle'
import Upload from '../components/Upload'
import _ from 'lodash'
import dayjs from 'dayjs'
import store from '@/store'

/**
 * 过滤sku中相同prop_xxx和in_prop_xxx的属性
 * 两者同时存在时只保留prop_xxx
 * @param {Array<{name: string}>} items - 待处理的sku属性数组
 * @returns {Array} 过滤后的新数组
 */
function filterSku(items) {
    const newItems = [];
    const existIndexMap = new Map();

    for (const item of items) {
        const { name } = item;
        // 处理prop_xxx
        if (name.startsWith('prop_')) {
            const inPropKey = `in_${name}`;
            if (existIndexMap.has(inPropKey)) {
                // 覆盖操作
                newItems[existIndexMap.get(inPropKey)] = item;
                item.rules =  {...item.rules, allowCreate: !!items.find(i => i.name === inPropKey)}
                existIndexMap.set(name, existIndexMap.get(inPropKey));
                existIndexMap.delete(inPropKey);
            } else {
                item.rules =  {...item.rules, allowCreate: !!items.find(i => i.name === inPropKey)}
                newItems.push(item);
                existIndexMap.set(name, newItems.length - 1);
            }
            continue;
        }
        // 处理in_prop_xxx
        if (name.startsWith('in_prop_')) {
            const propKey = name.slice(3); // 去掉'in_'前缀
            if (!existIndexMap.has(propKey)) {
                newItems.push(item);
                existIndexMap.set(name, newItems.length - 1);
            }
            continue;
        }
        // 普通属性直接添加
        newItems.push(item);
    }
    return newItems;
}

export const needLimitImgFields = ['white_bg_image', 'item_images', 'three_to_four_item_images', 'wireless_desc','vertical_image'];
// 一些图片的限制生成
function _genImagesLimit(item) {
    // 若不是需要处理的图片字段就不处理了
    const autoCropImageConfigList = (localStorage.getItem('autoCropImageConfigList') || '').split(',');

    if (!needLimitImgFields.includes(item.name)) {
        return {}
    }
    let {maxTargetSizeRule, maxImageSizeRule, minImageSizeRule, tipRule} = item.rules || {}
    if (item.name === 'item_images') {
        let isCheckItemImg = !autoCropImageConfigList.includes('itemImages');
        // 由于商品图片规则比较奇怪，给的规则字段与tipRule对不上,直接写死限制先
        return {
            limitSize: Number(maxTargetSizeRule) || 500 * 1024,
            limitSuffix: '.jpg,.jpeg,.png',
            aspectRatio: isCheckItemImg ? 1 : null,
            aspectRatioText: isCheckItemImg ? '1:1' : null,
            _needLimit: true,
            limitNums: 50,
            supportAiRetry: true
        }
    }
    
    if(item.name === 'white_bg_image'){
        let isCheckBgImg = !autoCropImageConfigList.includes('whiteBgImage');
        return {
            limitSize: 3 * 1024 * 1024,  // 透明素材图限制为3M
            limitWidth: isCheckBgImg ? [800, 800] : [0,0],
            limitHeight: isCheckBgImg ? [800, 800] : [0,0],
            aspectRatio: isCheckBgImg ? 1 : null,
            aspectRatioText: isCheckBgImg ? '1:1' : null,
            cropDefaultSize: isCheckBgImg ? [800, 800] : [0,0],
            _needLimit: true
        }
    }
    if (item.name === 'three_to_four_item_images') {
        let isCheckMainImg34 = !autoCropImageConfigList.includes('mainImg34');
        return {
            limitSize: Number(maxTargetSizeRule) || 500 * 1024,
            limitSuffix: '.jpg,.jpeg,.png',
            limitNums: 5,
            autoCropImageParams:{targetWidth:750,targetHeight:1000},
            limitWidth: isCheckMainImg34 ? [750, 0] : [0,0],
            limitHeight: isCheckMainImg34 ? [1000, 0] : [0,0],
            aspectRatio: isCheckMainImg34 ? 0.75 : null,
            aspectRatioText: isCheckMainImg34 ? '3:4' : null,
            cropDefaultSize: isCheckMainImg34 ? [750, 1000] : [0,0],
            _needLimit: true
        }
    }
    if (item.name === 'vertical_image') {
        let isCheckVerticalImg = !autoCropImageConfigList.includes('verticalImage');
        return {
            limitSize: 20 * 1024 * 1024,
            limitSuffix: '.jpg,.jpeg,.png',
            limitWidth: isCheckVerticalImg ? [800, 0] : [0,0],
            limitHeight: isCheckVerticalImg ? [1200, 0] : [0,0],
            cropDefaultSize: isCheckVerticalImg ? [800, 1200] : [0,0],
            _needLimit: true,
            autoCropImageParams:{publishAutoCropImageEnum:'TM_VerticalImage'}
        }
    }
    
    
    if (item.name === 'wireless_desc') {
        let isCheckDesc = !autoCropImageConfigList.includes('wirelessDesc');
         if(item._noDescription){// 新版无线端详情描述
            return {
                limitSuffix: '.jpg,.jpeg,.png',
                limitWidth: isCheckDesc ? [480, 1500] : [0,0],
                limitHeight: isCheckDesc ? [0, 2000] : [0,0],
                limitNums: 50,
                limitSize: 10 * 1024 * 1024,
                _needLimit: true,
                supportAiRetry: true,
                autoCropImageParams:{targetWidth:480,targetHeight:480}
            }
        }else{
            // 由于商品图片规则比较奇怪，给的规则字段与tipRule对不上,直接写死限制先
            return {
                limitSuffix: '.jpg,.jpeg,.png',
                limitWidth: isCheckDesc ? [750, 1242] : [0,0],
                limitHeight: isCheckDesc ? [0, 1546] : [0,0],
                limitNums: 50,
                limitSize: 10 * 1024 * 1024,
                _needLimit: true,
                supportAiRetry: true,
                autoCropImageParams:{publishAutoCropImageEnum:'TM_WirelessDesc'}
            }
        }
    }
    // 生成符合图片上传组件适用的属性
    let limits = {
        limitNums: 5,
        limitWidth: [0, 0],
        limitHeight: [0, 0]
    }
    if(item.name === 'white_bg_image'){
        limits.autoCropImageParams = {publishAutoCropImageEnum:'TM_WhiteBgImage'}
    }
    if (maxTargetSizeRule) {
        limits.limitSize = Number(maxTargetSizeRule)
        limits._needLimit = true;
    }
    if (maxImageSizeRule) {
        let maxS = maxImageSizeRule.split('x')
        limits.limitHeight[1] = maxS[1]
        limits.limitWidth[1] = maxS[0]
        limits._needLimit = true;
    }
    if (minImageSizeRule) {
        let minS = minImageSizeRule.split('x')
        limits.limitHeight[0] = minS[1]
        limits.limitWidth[0] = minS[0]
        limits._needLimit = true;
    }
    if (tipRule) {
        // 有些图片限制需要通过tipRule描述，如比例
        // 一些正则匹配
        let regAspectRatio = /横竖比必须为(\d+：\d+)/
        let regMinWidth = /最小长度为(\d+)/

        // 匹配比例 
        let aspectRatio = tipRule.match(regAspectRatio);
        if (aspectRatio) {
            aspectRatio = aspectRatio[1];
            let _asp = aspectRatio.split('：')
            limits.aspectRatio = _asp[0] / _asp[1]
            limits.aspectRatioText = aspectRatio
            limits._needLimit = true;
        }

        // 匹配最小宽度
        let minWidth = tipRule.match(regMinWidth)
        if (minWidth) {
            minWidth = minWidth[1]
            limits.limitWidth[0] = minWidth
            limits._needLimit = true;
        }

    }
    return limits
}

// 根据rule生成url类型的限制条件
function genUrlLimit(rules = {}) {
    let limitSize = Number(rules.maxTargetSizeRule || 0)
    let limitWidth = [0, 0]
    let limitHeight = [0, 0]
    let tips = ''
    let _needLimit = false
    if (rules.maxImageSizeRule) {
        const [maxWidth, maxHeight] = rules.maxImageSizeRule.split('x').map(Number)
        maxWidth && (limitWidth[1] = maxWidth)
        maxHeight && (limitHeight[1] = maxHeight)
        if (rules.maxImageSizeRule === rules.minImageSizeRule) {
            tips += `限制${rules.maxImageSizeRule}像素`
        } else {
            tips += `限制最大${rules.maxImageSizeRule}像素`
        }
        _needLimit = true
    }
    if (rules.minImageSizeRule) {
        const [minWidth, minHeight] = rules.minImageSizeRule.split('x').map(Number)
        minWidth && (limitWidth[0] = minWidth)
        minHeight && (limitHeight[0] = minHeight)
        if (rules.maxImageSizeRule !== rules.minImageSizeRule) {
            tips += ` 限制最小${rules.minImageSizeRule}像素`
            _needLimit = true
        }
    }

    if (limitSize > 0) {
        tips += ` 限制大小${(limitSize / 1024 / 1024).toFixed(2)}M`
        _needLimit = true
    }

    tips = tips.split(' ').filter(Boolean).join(',')

    return {limitSize, limitWidth, limitHeight, tips, _needLimit }
}

const editorImageAttrs = (item) => {
    let extraAttr = {}
    if(item.name === 'description' ||  item.name.startsWith('desc_module_')) {
        extraAttr = {
            limitSize: 10 * 1024 * 1024,
            limitWidth: [0, 10000],
            limitHeight: [0, 10000],
            limitNums: 50,
        }
    } 
    // else if(item.name === 'wireless_desc') {
    //     extraAttr = {
    //         limitSize: 10 * 1024 * 1024,
    //         limitWidth: [0, 1242],
    //         limitHeight: [0, 1242],
    //         limitNums: 50,
    //     }
    // }
    return extraAttr
}

export const typeMap = {
    // INPUT，说明当前field的值为文本输入型。
    INPUT: item => {
        const { properties, name, parentName, rules, _step } = item
        const { valueTypeRule, tipRule, maxDecimalDigitsRule, maxLengthRule  } = rules || {}

        // 特殊处理
        // name 为 "desc" || "wirelessDesc"
        // 这两个为富文本输入，对应PC端详情与移动端详情
        if (["desc", "wirelessDesc", "description"].includes(name)) {
            return {
                component: Editor,
                props: {dataSource: item, name, parentName, extraAttr: editorImageAttrs(item)}
            }
        }
        // 特殊处理
        // name 为 "postage_id"
        // 可能有多个店铺，且需要向后端获取模板列表
        if ("postage_id" === name) {
            return {
                component: PostageSelects,
                props: {dataSource: item, name, parentName}
            }
        }


        if (Array.isArray(properties) && properties.length > 0) {
            return {
                component: Input,
                props: { dataSource: item, name, parentName }
            }
        } else if (valueTypeRule === 'decimal') {
            return {
                component: InputNumber,
                props: {
                    min: 0,
                    precision: 2,
                    name,
                    parentName,
                    dataSource: item,
                    tipRule: (tipRule || '').split(';').filter(Boolean)
                }
            }
        } else if (valueTypeRule === 'integer') {
            return {
                component: InputNumber,
                props: {
                    min: 0,
                    precision: 0,
                    name,
                    parentName,
                    dataSource: item,
                    tipRule: (tipRule || '').split(';').filter(Boolean)
                }
            }
        } else if (valueTypeRule === 'url') {
            return {
                component: Upload,
                props: {name, parentName, className: 'pic', extraAttr: {
                    ...genUrlLimit(rules),
                    ..._genImagesLimit(item)
                }}
            }
        } else if (valueTypeRule === 'date') {
            return {
                component: Input,
                props: {
                    style: {
                        width: '100%'
                    },
                    name,
                    parentName
                }
            }
        } else if (valueTypeRule === 'time') {
            let time_extra_props = {}
            if (name === 'start_time' && _step === '3') {
                // 第三步的开始时间一般不能选择当前时间之前的
                time_extra_props['min-time'] = dayjs().add(10, 'min').format('YYYY-MM-DD HH:mm:ss')
            }
            return {
                component: InputTime,
                props: {dataSource: item, name, parentName, ...time_extra_props}
            }
        } else if (/html/.test(valueTypeRule)) {
            return {
                component: Editor,
                props: {
                    placeholder: '请输入',
                    name,
                    parentName,
                    dataSource: item,
                    tipRule,
                    extraAttr: editorImageAttrs(item)
                }
            }
        } else if(maxDecimalDigitsRule) {
            return {
                component: InputNumber,
                props: {
                    precision: parseFloat(maxDecimalDigitsRule),
                    name,
                    parentName,
                    dataSource: item,
                    tipRule: (tipRule || '').split(';').filter(Boolean)
                }
            }
        } else {
            return {
                component: Input,
                props: {
                    placeholder: '请输入',
                    name,
                    parentName,
                    dataSource: item,
                    maxLengthRule: item.rules.maxLengthRule || '',
                    showSuffixLength: ['title', 'sell_point_0'].includes(name),
                    tipRule: (tipRule || '').split(';').filter(Boolean)
                }
            }
        }
    },
    // MULTIINPUT ，说明当前field的值为多行文本输入型。
    MULTIINPUT: item => {
        const { name } = item
        return { component: Input, props: { name } }
    },
    // SINGLECHECK，说明当前field的值为单选输入型，类似于radio。
    SINGLECHECK: item => {
        const { options, name, parentName, _step } = item
        const selectMap = {
            '1': Step1Select
        }
            return { component: selectMap[_step] || Select, props: { dataSource: item, name } }
    },
    // MULTICHECK ，说明当前field的值为多选输入型，类似于checkbox。
    MULTICHECK: item => {
        const { options, name, parentName } = item 
        let props =  { dataSource: item, multiple: true, name }
        if(name === 'seller_cids'){
            props = {
                ...props,
                style: {
                    width: '100%'
                },
            }
        }
        return { component: Select, props }
    },
    // COMPLEX ，说明当前field的值为复合结构，表示数据的聚合。
    COMPLEX: item => {
        const { name, parentName, rules } = item
        let { tipRule } = rules  || {}
        // 特殊处理几种复合型控件
        const specialCompMap = {
            "item_images": Images,
            "item_wireless_images": Images,
            "three_to_four_item_images": Images,
            "wireless_desc": Images,
            "shopping_title": ShoppingTitle,
        }
        if(name === 'item_images') {
            tipRule += ';商品图片支持上传多张，上限50，商品发布时，按照平台发布规则选择前5张'
        }
        if(name === 'wireless_desc' && item._noDescription){ // 新版手机端详情描述
            tipRule = tipRule || '<div>1.上传【旺铺无线详情描述】后，将分别在电脑端和手机端展示，仅支持上传图片</div><div>2. 图片类型支持png、jpg、jpeg，要求单个图片的原图宽度为480px~1500px，高度≤2000px。</div>'
        }
        return {
            component: specialCompMap[name] || Complex,
            props: {
                dataSource: item,
                name,
                parentName,
                tipRule: (tipRule || '').replaceAll(';', ";<br/>"),
                extraAttr: {
                    ..._genImagesLimit(item)
                }
            }
        }
    },
    // MULTICOMPLEX ，说明当前field的值为复合结构，与complex有差别的在于multiComplex的field是可以有多份数据实例样本。
    MULTICOMPLEX: item => {
        const { name, parentName, rules, _step } = item
        const { tipRule } = rules || {}
        const componentsMap = {
            'sku': Specifications,
            'packList': MultiComplex,
            'cspuList': MultiComplex,
            'auctionVideos': AuctionVideos,
            'size_model_try': SizeModelTry,            
        }
        // const defaultComp = _step === '2' ? MultiComplex : Input
        if (name === 'sku') {
            item.children = filterSku(item.children);
        }

        return { component: componentsMap[name] || MultiComplex, props: { dataSource: item, name, parentName, tipRule: (tipRule || '').replaceAll(';', ";<br/>") } }
    }
}

/**
 * 生成field
 * @param {*} fields 
 * @returns 
 */
const generateField = (fields, parentName) => {
    return fields.reduce((field, item) => {
        // 暂时屏蔽多实例符合类型
        if (item.type === 'MULTICOMPLEX') {
            return field
        }

        if (item.children) {
            item.children = generateField(item.children, item.name)
        }
        parentName && (item.parentName = parentName)
        item.rules = getRules(item) // rule
        item.component = typeMap[item.type](_.cloneDeep(item))
        return field.concat(item)
    }, [])
}


/**
 * 获取field
 * @param {*} fields 
 * @returns 
 */
export const getField = (fields) => {
    if (!Array.isArray(fields) || fields.length <= 0) return []
    return generateField(fields)
}